module.exports = __webpack_public_path__ + "fonts/CangErShuYuanTiW03-2.8205eccf.ttf";